<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>User Management Detail</strong>
        </div>

        <b-row>
          <b-col md="12">

            <b-row class="my-1">
              <b-col md="4">
                <label>Username</label>
              </b-col>
              <b-col md="8">
                <div v-if="isAdmin">
                  <b-form-input required type="text" v-validate="{required: true, min: 1, max: 50, regex: /^[\w]+$/ }" v-model="user.NAME" name="Username"></b-form-input>
                </div>
                <div v-else>
                  <label>{{user.NAME}}</label>
                </div>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>First Name</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="text" v-validate="{required: true,min: 0, max: 20, regex: /^[\w\s']+$/ }" v-model="user.FIRST_NAME" name="FirstName"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Last Name</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="text" v-validate="{required: true,min: 0, max: 20, regex: /^[\w\s']+$/ }" v-model="user.LAST_NAME" name="LastName"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4"><label>Title:</label></b-col>
              <b-col md="8">
                <b-form-select ref="titleSelect" required v-model="user.TITLE_ID">
                  <option v-for="t in titles" :value="t.Id" v-bind:key="t.Id">{{ t.Name }}</option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-row v-if="isAdmin" class="my-1 align-items-center">
              <b-col md="4">
                <label>Has mPortal access</label>
              </b-col>
              <b-col md="8">
                <c-switch id="swHasDealPortAccDetail" @change="dealerPortalAccessChanged(user)" v-model="user.ACCESS_DEALER_PORTAL" type="text" variant="primary" on="Yes" off="No" :pill="true" />
              </b-col>
            </b-row>

            <b-row v-if="isAdmin" class="my-1 align-items-center">
              <b-col md="4">
                <label>Kiosk Mode</label>
              </b-col>
              <b-col md="8">
                <c-switch id="swKioskMode" @change="kioskModeChanged(user)" v-model="user.KIOSK_MODE" type="text" variant="primary" on="Yes" off="No" :pill="true" />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4"><label>Timezone:</label></b-col>
              <b-col md="8">
                <b-form-select v-model="user.TIMEZONE_ID" :options="user.TIMEZONES">
                </b-form-select>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Email</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="email" v-validate="{required: true,email: true, min: 1, max: 40}" v-model="user.EMAIL" name="Email"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4"><label>Manager:</label></b-col>
              <b-col md="8">
                <b-form-select ref="managerSelect" required v-model="user.MANAGER_USER_ID">
                  <option v-for="m in managers" :value="m.USER_ID" v-bind:key="m.USER_ID">{{ m.FIRST_NAME }} {{ m.LAST_NAME }} - {{ m.EMAIL }}</option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Comment</label>
              </b-col>
              <b-col md="8">
                <b-form-textarea v-model="user.COMMENT"
                                 v-validate="{min: 0, max: 256 }"
                                 name="Comment"
                                 :rows="3"
                                 :max-rows="6">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <!--<span v-model="errors">{{ validateErrors.items }}</span>-->
              <b-list-group style="min-width:100%">
                <b-list-group-item class="py-2" variant="danger" v-for="err in validateErrors.items" :key="err.id"> {{ err.msg }} </b-list-group-item>
              </b-list-group>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <button id="btnSetDefPass" class="btn btn-success ml-1" @click="setDefaultPassword" v-if="user.USER_ID !== undefined">
            <i title="Set Default Password" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Reset to Default Password</strong>
          </button>
        </b-row>
        <div slot="footer">
          <b-col class="d-flex m-0 p-0">
            <button id="btnRetToUsers" class="btn btn-warning" @click="closeModal">
              <i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Users</strong>
            </button>
            <button id="btnSave" class="btn btn-info ml-auto" @click="saveUser">
              <i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong>
            </button>

          </b-col>
        </div>
      </b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { setTimeout } from 'timers'
import VeeValidate from 'vee-validate'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  props: {
    selUserId: Number
  },
  created () {
    var self = this

    if (this.$route.params.userId && parseInt(this.$route.params.userId) !== -1) {
      this.$props.selUserId = parseInt(this.$route.params.userId)
    }

    if (this.$props.selUserId > 0) {
      axios.get('/api/UserManagement/Get?userId=' + this.$props.selUserId)
        .then(response => {
          this.boolLoading = false
          if (response.data === undefined || response.data === null) {
            this.user = {}
          } else {
            this.user = response.data
          }
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    } else if (this.$props.selUserId && parseInt(this.$props.selUserId) === -1) {
      axios.get('/api/UserManagement/GetTimeZones')
        .then(response => {
          this.boolLoading = false
          if (response.data === undefined || response.data === null) {
            self.user = {}
          } else {
            self.user.TIMEZONES = response.data
          }
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    } else {
      setTimeout(function () {
        self.user = {}
        self.boolLoading = false
      }, 500)
    }
    axios.get('/api/UserManagement/GetAll')
      .then(response => {
        this.managers = response.data.USERS
        this.titles = response.data.TITLES
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      user: {},
      managers: [],
      titles: [],
      myinput: ''
    }
  },
  methods: {
    closeModal () {
      this.$emit('clicked', true)
    },
    saveUser (p) {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.$dialog.confirm('Are you sure you would like to save changes?')
            .then(function () {
              var obj = {
                USER_ID: self.user.USER_ID,
                NAME: self.user.NAME,
                FIRST_NAME: self.user.FIRST_NAME,
                LAST_NAME: self.user.LAST_NAME,
                EMAIL: self.user.EMAIL,
                COMMENT: self.user.COMMENT,
                ACCESS_DEALER_PORTAL: self.user.ACCESS_DEALER_PORTAL,
                KIOSK_MODE: self.user.KIOSK_MODE,
                TIMEZONE_ID: self.user.TIMEZONE_ID,
                MANAGER_USER_ID: self.user.MANAGER_USER_ID,
                TITLE_ID: self.user.TITLE_ID
              }

              axios.post('/api/UserManagement/Save', obj)
                .then(response => {
                  self.errMsg = 'Your changes has been saved'
                  self.dismissibleType = 'success'
                  self.showDismissibleAlert = true
                  self.boolLoading = false
                  self.$emit('clicked', true)
                  // if (self.user.USER_ID === undefined) {
                  //  self.user['USER_ID'] = parseInt(response.data)
                  // }
                })
                .catch(error => {
                  if (error.response.status == 403) {
                    self.$router.push('/login')
                  }

                  self.boolLoading = false

                  self.errMsg = 'There was an error saving your changes : '
                  if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                    self.errMsg = self.errMsg + error.response.statusText
                  } else {
                    self.errMsg = self.errMsg + error
                  }

                  self.showDismissibleAlert = true
                })
            })
            .catch(function () {
              // do nothing
            })
        } else {
          // alert('Please correct errors first');

          self.errMsg = 'Please correct errors first'
          self.dismissibleType = 'danger'
          self.showDismissibleAlert = true

          setTimeout(function () {
            self.showDismissibleAlert = false
            self.errMsg = ''
          }, 8000)
        }
      })
    },
    setDefaultPassword (p) {
      var self = this

      self.$dialog.confirm('Are you sure you would like to reset password to default \'password\'?')
        .then(function () {
          var obj = {
            USER_ID: self.user.USER_ID
          }

          axios.post('/api/UserManagement/SetDefaultPassword', obj)
            .then(response => {
              self.errMsg = 'User\'s password was set to \'password\''
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              if (error.response.status == 403) {
                self.$router.push('/login')
              }

              self.boolLoading = false

              self.errMsg = 'There was an error resetting password to default : '
              if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                self.errMsg = self.errMsg + error.response.statusText
              } else {
                self.errMsg = self.errMsg + error
              }

              self.showDismissibleAlert = true
            })
        })
        .catch(function () {
          // do nothing
        })
    },
    dealerPortalAccessChanged (user) {
      var self = this
      if (parseInt(user.USER_ID) === 1) {
        setTimeout(function () {
          user.ACCESS_DEALER_PORTAL = true
        }, 500)
      }
    },
    kioskModeChanged (user) {
      var self = this
      if (parseInt(user.USER_ID) === 1) {
        setTimeout(function () {
          user.KIOSK_MODE = true
        }, 500)
      }
    }
  },
  computed: {
    isAdmin: function () {
      return parseInt(this.user.USER_ID) !== 1
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/UserManagementDetail.vue